import { HashRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import Navbar from "./Layouts/Navbar";
import Home from "./Pages/Home";
import { Toaster } from "react-hot-toast";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import { analyticsReady } from "./lib/firebase";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Contact from "./Components/Contac2";
import LaunchLoader from "./Components/rebrand/LaunchLoader";
import Blog from "./Pages/Blog";
import BlogPost from "./Pages/BlogPost";
import Articles from "./Pages/Articles";
import ArticleDetail from "./Pages/ArticleDetail";
import AdminLogin from "./Pages/AdminLogin";
import AdminArticleEditor from "./Pages/AdminArticleEditor";
import RequireAuth from "./Components/admin/RequireAuth";
import ApiLayout from "./Pages/api/ApiLayout";
import ApiOverview from "./Pages/api/ApiOverview";
import NetworkPage from "./Pages/api/NetworkPage";

// Legacy /api/:slug links → /networks/:slug (the page resolves aliases).
const LegacyApiRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/networks/${slug}`} replace />;
};

function App() {
  useEffect(() => {
    analyticsReady.then((analytics) => {
      if (analytics) logEvent(analytics, "page_view");
    });
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const root = document.documentElement;
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateScrollDirection = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        root.dataset.scrollDirection = "down";
      } else if (currentScrollY < lastScrollY) {
        root.dataset.scrollDirection = "up";
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDirection);
        ticking = true;
      }
    };

    root.dataset.scrollDirection = "down";
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      delete root.dataset.scrollDirection;
    };
  }, []);

  return (
    <div className="App">
      <LaunchLoader />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Navbar />}>
            <Route index element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/nodes" element={<Contact />} />
            <Route path="/audit" element={<Blog />} />
            <Route path="/audit/:slug" element={<BlogPost />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/networks" element={<ApiLayout />}>
              <Route index element={<ApiOverview />} />
              <Route path=":slug" element={<NetworkPage />} />
            </Route>
            {/* Former reference paths */}
            <Route path="/api" element={<Navigate to="/networks" replace />} />
            <Route path="/api/:slug" element={<LegacyApiRedirect />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/articles/new"
              element={
                <RequireAuth>
                  <AdminArticleEditor />
                </RequireAuth>
              }
            />
          </Route>
        </Routes>
      </HashRouter>
      <Toaster position="bottom-center" reverseOrder={false} />
    </div>
  );
}

export default App;
